/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * States that a module version can have in the workflow
 */
export type ModuleVersionState = (typeof ModuleVersionState)[keyof typeof ModuleVersionState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModuleVersionState = {
  draft: 'draft',
  pending_approval: 'pending_approval',
  published: 'published',
  retired: 'retired',
} as const;
